import { Alert, Stack } from "@mui/material"
import { useFindEmployeeList } from "../../api/EmployeeApi"
import { NexAutocomplete } from "../../components/Fields/Autocomplete"
import { DatePickerCustom } from "../../components/Fields/DatePickerCustom"
import { DataReceiptForm } from "../../models/DataReceipt"
import { EmployeeType, OfficeId, officeIdOptions } from "../../store/types/MissionsTypes"
import { TimeUtils } from "../../utils/TimeUtils"
import { useDataReceiptStore } from "../../zstore/DataReceiptStore"

export const ReceiptDetails = () => {
    const receiptDetailsForm = useDataReceiptStore((state) => state.receiptDetailsForm)
    const setReceiptDetailsForm = useDataReceiptStore((state) => state.setReceiptDetailsForm)

    const employeeList = useFindEmployeeList()

    const handleUpdate = <T extends keyof DataReceiptForm>(field: T, value?: DataReceiptForm[T]) => {
        setReceiptDetailsForm({ ...receiptDetailsForm, [field]: value })
    }

    if (employeeList.isError) {
        return <Alert severity={"error"}>{employeeList.error.message}</Alert>
    }

    return (
        <Stack width={280} gap={2}>
            <DatePickerCustom
                label={"Date Received"}
                value={TimeUtils.parseDate(receiptDetailsForm.date_received)}
                onChange={(value) => handleUpdate("date_received", TimeUtils.formatDate(value))}
                required={true}
            />
            <NexAutocomplete
                value={employeeList.data?.find((emp) => emp.employee_id === receiptDetailsForm.received_by) ?? null}
                options={employeeList.data ?? []}
                getOptionLabel={(emp: EmployeeType) => emp.employee_full_name}
                renderOption={(props, emp) => (
                    <li {...props} key={emp.employee_id}>
                        {emp.employee_full_name}
                    </li>
                )}
                TextFieldProps={{ label: "Logged By", required: true }}
                onChange={(_, value) => {
                    setReceiptDetailsForm({ ...receiptDetailsForm, received_by: value?.employee_id })
                }}
                loading={employeeList.isLoading}
                fullWidth={true}
            />
            <NexAutocomplete
                TextFieldProps={{ label: "Office Location", required: true }}
                value={receiptDetailsForm.office ?? null}
                options={officeIdOptions}
                onChange={(_, value) => handleUpdate("office", (value as OfficeId) ?? undefined)}
                fullWidth={true}
            />
        </Stack>
    )
}
